import { newSessionId } from "@vida/surf-core";

// SessionId telecomando per deck, valido per l'intera vita della pagina desktop
// (module-level: sopravvive a mount/unmount di PresentMode, muore col reload).
// Così un telefono già abbinato riprende il controllo al rientro in presentazione
// senza ri-scansionare il QR.
const sessions = new Map<string, string>();

export function getOrCreatePresentSession(deckId: string): string {
  let id = sessions.get(deckId);
  if (!id) {
    id = newSessionId();
    sessions.set(deckId, id);
  }
  return id;
}
